// dashboard card images (PNGs - kept as module imports, small files)
import globalEsgStandards from "../assets/images/dashboardCardImages/globalEsgStandards.png";
import climateAndCarbon from "../assets/images/dashboardCardImages/climateAndCarbon.png";
import operationalEsg from "../assets/images/dashboardCardImages/operationalEsg.png";
import industrialAndCountrySpecificEsgCompliance from "../assets/images/dashboardCardImages/industrialAndCountrySpecificEsgCompliance.png";
import esgAnalytics from "../assets/images/dashboardCardImages/esgAnalytics.png";
import supplierEsg from "../assets/images/dashboardCardImages/supplierEsg.png";
import fieldMonitoringApplication from "../assets/images/dashboardCardImages/fieldMonitoringApplication.png";
import esgVerification from "../assets/images/dashboardCardImages/esgVerification.png";
import capacityBuilding from "../assets/images/dashboardCardImages/capacityBuilding.png";

// dashboard SVG images served as static files from /public to avoid Babel processing
// (these files are >500KB and were causing build slowdowns when bundled)
const BASE = process.env.PUBLIC_URL + "/images/dashboadimg/";

const imgMap = {
    // Standard name keys
    GRI:                dashboardImg("dashboardimg1.svg"),
    SASB:               dashboardImg("dashboardimg2.svg"),
    TCFD:               dashboardImg("dashboardimg3.svg"),
    IFRS:               dashboardImg("dashboardimg4.svg"),
    "CSRD/ESRS (EU)":   dashboardImg("dashboardimg5.svg"),
    UNGC:               dashboardImg("dashboardimg6.svg"),
    SDG:                dashboardImg("dashboardimg7.svg"),
    CDP:                dashboardImg("dashboardimg8.svg"),
    WB:                 dashboardImg("dashboardimg9.svg"),
    "IFC PSs":          dashboardImg("dashboardimg10.svg"),
    "Equator Principles": dashboardImg("dashboardimg11.svg"),
    "ISO Standards":    dashboardImg("dashboardimg12.svg"),
    "OECD Guidelines":  dashboardImg("dashboardimg13.svg"),
    TNFD:               dashboardImg("dashboardimg14.svg"),
    "AA1000 Series":    dashboardImg("dashboardimg15.svg"),
    "PRI Principle":    dashboardImg("dashboardimg16.svg"),
    "IRIS+ (GIIN)":     dashboardImg("dashboardimg17.svg"),

    // Sub-image keys
    dashboardImg2_1:    dashboardImg("dashboardimg2_1.svg"),
    dashboardImg2_2:    dashboardImg("dashboardimg2_2.svg"),
    dashboardImg2_3:    dashboardImg("dashboardimg2_3.svg"),
    dashboardImg2_4:    dashboardImg("dashboardimg2_4.svg"),

    dashboardImg3_1:    dashboardImg("dashboardimg3_1.svg"),
    dashboardImg3_2:    dashboardImg("dashboardimg3_2.svg"),
    dashboardImg3_3:    dashboardImg("dashboardimg3_3.svg"),
    dashboardImg3_4:    dashboardImg("dashboardimg3_4.svg"),
    dashboardImg3_5:    dashboardImg("dashboardimg3_5.svg"),
    dashboardImg3_6:    dashboardImg("dashboardimg3_6.svg"),
    dashboardImg3_7:    dashboardImg("dashboardimg3_7.svg"),

    dashboardImg4_1:    dashboardImg("dashboardImg4_1.svg"),
    dashboardImg4_2:    dashboardImg("dashboardImg4_2.svg"),
    dashboardImg4_3:    dashboardImg("dashboardImg4_3.svg"),
    dashboardImg4_4:    dashboardImg("dashboardImg4_4.svg"),

    dashboardImg5_1:    dashboardImg("dashboardimg5_1.svg"),
    dashboardImg5_2:    dashboardImg("dashboardImg5_2.svg"),

    dashboardImg6_1:    dashboardImg("dashboardimg6_1.png"),
    dashboardImg6_2:    dashboardImg("dashboardImg6_2.svg"),

    dashboardImg7_1:    dashboardImg("dashboardimg7_1.svg"),
    dashboardImg7_2:    dashboardImg("dashboardimg7_2.svg"),

    // dashboard card images (PNGs)
    globalEsgStandards,
    climateAndCarbon,
    operationalEsg,
    industrialAndCountrySpecificEsgCompliance,
    esgAnalytics,
    supplierEsg,
    fieldMonitoringApplication,
    esgVerification,
    capacityBuilding,
};

function dashboardImg(filename) {
    return BASE + filename;
}

export default imgMap;
